module.exports = __webpack_public_path__ + "img/img-3.01708417.jpg";